import type { KeyboardEvent } from 'react';

/**
 * 中文输入法会用 Enter 确认候选词；这个按键不应同时提交表单。
 * keyCode 229 是部分浏览器在 IME 组合输入期间的兼容标记。
 */
export function isSubmitEnter(event: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>): boolean {
  return event.key === 'Enter'
    && !event.shiftKey
    && !event.nativeEvent.isComposing
    && event.keyCode !== 229;
}
